import React from "react";
var __jsx = React.createElement;
import { memo } from "react";
import Markdown from "markdown-to-jsx";
import { useCartActions, useItemCount } from "@/common/Contexts/CartContext";
import CartIcon from "./CartIcon";
import OilQuantityControl from "./OilQuantityControl";
import { trackEvents } from "@/common/events/events";
var OilOptionCard = function OilOptionCard(_ref) {
  var option = _ref.option,
    productId = _ref.productId,
    cartTitle = _ref.cartTitle,
    cartSubtitle = _ref.cartSubtitle,
    productLogo = _ref.productLogo,
    productName = _ref.productName,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? "oil_listing" : _ref$referralLocation;
  var _useCartActions = useCartActions(),
    addItem = _useCartActions.addItem,
    removeItem = _useCartActions.removeItem,
    updateQuantity = _useCartActions.updateQuantity;
  var count = useItemCount(option.id);
  var currentText = option.price.current_formatted;
  var originalText = option.price.original_formatted;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 border-[0.5px] border-solid border-[#E6E9EF] bg-[#F4F5F8] rounded-lg px-2 py-0 md:px-2 md:py-1 min-h-[58px] md:min-h-0 flex-[0_0_134px] md:flex-1 md:gap-2  md:rounded-lg md:max-w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 min-w-0 gap-1.5 md:gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-base md:text-lg font-bold text-[#EC6234] whitespace-nowrap leading-none"
  }, option.value_formatted), /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline gap-1.5 md:gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-sm md:text-base font-bold text-[#00143C] whitespace-nowrap"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: currentText
  }, option.price.current_formatted)), /*#__PURE__*/React.createElement("span", {
    className: "text-xs md:text-sm text-[#B0B0B0] whitespace-nowrap"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: originalText,
    className: "strike-adjust-wrap"
  }, option.price.original_formatted)))), count > 0 ? /*#__PURE__*/React.createElement(OilQuantityControl, {
    count: count,
    onDecrease: function onDecrease() {
      return count === 1 ? removeItem(option.id) : updateQuantity(option.id, count - 1);
    },
    onIncrease: function onIncrease() {
      var _option$max_count;
      if (count < ((_option$max_count = option.max_count) !== null && _option$max_count !== void 0 ? _option$max_count : 99)) updateQuantity(option.id, count + 1);
    },
    onSetCount: function onSetCount(value) {
      var _option$max_count2;
      var max = (_option$max_count2 = option.max_count) !== null && _option$max_count2 !== void 0 ? _option$max_count2 : 99;
      if (value <= 0) {
        removeItem(option.id);
      } else {
        updateQuantity(option.id, Math.min(value, max));
      }
    }
  }) : /*#__PURE__*/React.createElement("button", {
    className: "bg-white border-[0.5px] border-solid border-[#E6E9EF] rounded-[4.5px] w-[40px] h-[40px] md:w-auto md:h-auto md:rounded-lg md:p-2 cursor-pointer flex items-center justify-center flex-shrink-0 transition-colors hover:bg-[#eef0fb] hover:border-[#3C56D4]",
    onClick: function onClick() {
      addItem({
        id: option.id,
        type: "coupon",
        price: {
          current: option.price.current,
          current_formatted: currentText,
          original: option.price.original,
          original_formatted: originalText
        },
        meta: {
          title: cartTitle,
          subtitle: cartSubtitle,
          logo: productLogo,
          size: option.value_formatted
        }
      });
      trackEvents("vas_add_to_cart", {
        product_id: productId,
        product_name: productName !== null && productName !== void 0 ? productName : cartTitle,
        product_variant: option.value_formatted,
        vas_category: "oil",
        referral_location: referralLocation
      });
    },
    "aria-label": "add to cart"
  }, /*#__PURE__*/React.createElement(CartIcon, null)));
};
export default /*#__PURE__*/memo(OilOptionCard);